<div *ngIf="loading" [@fadeInOut]
     style="position: absolute; background: rgba(255, 255, 255, 1); top: 0; left: 0; height: 100%; width: 100%; z-index: 50; text-align: center;">
  <sb-icon class="spinner" icon="loadingBlockAnimation" [animationOptions]="{autoplay: true, loop:true}"
           [style.color]="'#004F90'"></sb-icon>
</div>
<div class="row" style="min-height: 500px;">
  <div class="col">
    <div class="row" *ngIf="!loading" [@fadeInOut]>
      <div class="col-sm-12 col-md-6">
        <div class="row mb-2">
          <div class="col-12">
            <div class="tablewrap">
              <div class="mt-3 ml-3 d-flex justify-content-between">
                <h5>
                  {{ 'lang.globals.pairing'|translate }}
                </h5>
                <h5 class="mr-2">
                  {{ 'lang.deviceDetails.paired' | translate }}
                  <sb-icon *ngIf="device.paired" icon="success" class="green"></sb-icon>
                  <sb-icon *ngIf="!device.paired" icon="error" class="grey"></sb-icon>
                </h5>
              </div>
              <div *ngIf="!device.paired && permissionService.hasPermission(permissionService.Permission.device_pair)"
                   class="d-flex flex-row bb">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{ 'lang.device.pair' | translate }}</p>
                  <p class="w-100 tr">
                    <button class="btn btn-success"
                            (click)="pair()">
                      <sb-icon icon="link"></sb-icon>&nbsp;
                    </button>
                  </p>
                </div>
              </div>
              <div *ngIf="device.paired && permissionService.hasPermission(permissionService.Permission.device_unpair)"
                   class="d-flex flex-row bb">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{ 'lang.device.unpair' | translate }}</p>
                  <p class="w-100 tr">
                    <button class="btn btn-danger" (click)="unpair()">
                      <sb-icon icon="linkNone"></sb-icon>
                    </button>
                  </p>
                </div>
              </div>
              <div *ngIf="device.paired && permissionService.hasPermission(permissionService.Permission.device_repair)"
                   class="d-flex flex-row bb">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{ 'lang.device.re_pair' | translate }}</p>
                  <p class="w-100 tr">
                    <button class="btn btn-secondary" (click)="pair()">
                      <sb-icon icon="link"></sb-icon>
                    </button>
                  </p>
                </div>
              </div>
              <div *ngIf="device.serviceRequest" class="d-flex flex-row bb">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{ 'lang.device.deviceRequiresService' | translate }}</p>
                  <p
                    *ngIf="permissionService.hasPermissions([permissionService.Permission.device_attributes_edit, permissionService.Permission.notification_read])"
                    class="w-100 tr">
                    <button class="btn btn-success" (click)="service()">
                      <sb-icon icon="setting"></sb-icon>
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12">
            <div class="tablewrap">
              <div class="mt-3 ml-3">
                <h5>
                  {{ 'lang.globals.deviceCommands'|translate }}
                </h5>
              </div>
              <div class="d-flex flex-row bb" *ngPermissions="permissionService.Permission.device_exit_player">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{ 'lang.device.exitPlayer' | translate }}</p>
                  <p class="w-100 tr">
                    <button class="btn btn-danger" (click)="exitPlayer()">
                        <sb-icon icon="standBy"></sb-icon>
                    </button>
                  </p>
                </div>
              </div>
              <div class="d-flex flex-row bb" *ngPermissions="permissionService.Permission.device_reboot">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{ 'lang.device.rebootDevice' | translate }}</p>
                  <p class="w-100 tr">
                    <button class="btn btn-danger" (click)="rebootDevice()">
                      <sb-icon icon="undo"></sb-icon>
                    </button>
                  </p>
                </div>
              </div>
              <div class="d-flex flex-row bb" *ngPermissions="permissionService.Permission.device_clear_local_data">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{ 'lang.device.clearLocalData' | translate }}</p>
                  <p class="w-100 tr">
                    <button class="btn btn-danger" (click)="clearLocalData()">
                      <sb-icon icon="selection"></sb-icon>
                    </button>
                  </p>
                </div>
              </div>
              <div class="d-flex flex-row bb" *ngPermissions="permissionService.Permission.device_clear_local_settings">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{ 'lang.device.clearLocalSettings' | translate }}</p>
                  <p class="w-100 tr">
                    <button class="btn btn-danger" (click)="clearLocalSetting()">
                      <sb-icon icon="wrench"></sb-icon>
                    </button>
                  </p>
                </div>
              </div>
              <div class="d-flex flex-row bb" *ngPermissions="permissionService.Permission.device_playlist_cache_delete">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{ 'lang.globals.deleteDevicePlaylistCache' | translate }}</p>
                  <p class="w-100 tr">
                    <button class="btn btn-danger" (click)="clearDevicePlaylistCache()">
                      <sb-icon icon="schedules"></sb-icon>
                    </button>
                  </p>
                </div>
              </div>
              <div class="d-flex flex-row bb"
                   *ngIf="isCalibrationPossible() && permissionService.hasPermission(permissionService.Permission.device_show_calibration_image)">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{ 'lang.device.calibrationImage' | translate }}</p>
                  <p class="w-100 tr">
                    <button class="btn btn-danger" (click)="calibrationImage()">
                      <sb-icon icon="expand"></sb-icon>
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-2" *ngPermissions="permissionService.Permission.device_export_offline_playlist">
          <div class="col-12">
            <div class="tablewrap">
              <div class="d-flex flex-row bb">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{ 'lang.device.downloadOfflinePlaylist' | translate }}</p>
                  <p class="w-100 tr">
                    <button class="btn btn-primary"
                            (click)="downloadOfflinePlaylist()">
                      <sb-icon [icon]="'download'"></sb-icon>
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngPermissions="permissionService.Permission.device_delete" class="row mb-2">
          <div class="col-12">
            <div class="tablewrap">
              <div class="d-flex flex-row bb">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{ 'lang.globals.delete' | translate }}</p>
                  <p class="w-100 tr">
                    <button class="btn btn-danger"
                            (click)="deleteDevice()">
                      <sb-icon icon="trash"></sb-icon>
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          *ngIf="device?.attributes?.length > 0 && permissionService.hasPermissions([permissionService.Permission.device_attributes_edit, permissionService.Permission.device_attribute_datatype_list])"
          class="row mb-2">
          <div class="col-12">
            <div class="tablewrap">
              <div class="mt-3 ml-3">
                <h5>
                  {{ 'lang.globals.attributes'|translate }}
                </h5>
              </div>
              <div class="d-flex flex-row">
                <div
                  class="row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <ng-scrollbar class="mt-2" style="height: 150px; width: 100%" [track]="'vertical'">

                    <div *ngFor="let attribute of device?.attributes" class="d-flex tw-mr-5 tw-mb-1">
                      <p class="w-100">{{ attribute.name }}</p>
                      <div class="d-flex justify-content-end w-100">
                        @if (attribute?.datatype?.allowedValues?.length > 0) {
                          <sb-comp-string-dropdown-select
                            class="w-100"
                            [disabled]="!permissionService.hasPermission(permissionService.Permission.device_attributes_edit) || !attribute?.datatype?.adPlacerAbleToSet "
                            [singleSelectMode]="false" [showSubmit]="false" [hidePagination]="true"
                            [inputData]="attribute.datatype.allowedValues" [dropDownDatatype]="'ATTRIBUTE'"
                            (selectedDataEmitter)="updateAttribute(attribute, $event)" [showColumnIcon]="false"
                            [showIcon]="false" [frontendSearch]="true"
                            [selectedInputData]="getAttributeInputData(attribute)">
                          </sb-comp-string-dropdown-select>
                        } @else {
                          <input type="text" class="form-control text-right"
                                 [disabled]="!attribute?.datatype?.adPlacerAbleToSet || !permissionService.hasPermission(permissionService.Permission.device_attributes_edit)"
                                 placeholder="..." [(ngModel)]="attribute.value">
                        }
                      </div>
                    </div>
                  </ng-scrollbar>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngPermissions="permissionService.Permission.device_properties_show" class="col-sm-12 col-md-6">
        <div class="row mb-2">
          <div class="col-12">
            <div class="tablewrap">
              <div class="mt-3 ml-3">
                <h5>
                  {{ 'lang.globals.properties'|translate }}
                </h5>
              </div>
              <div class="d-flex flex-row bb">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{ 'lang.globals.identifier' | translate }}</p>
                  <p class="w-100 tr">
                    <input [disabled]="!permissionService.hasPermission(permissionService.Permission.device_properties_edit)" type="text"
                           class="form-control text-right" placeholder="..." [ngModel]="identifier"
                           (ngModelChange)="onIdentifier($event)">
                  </p>
                </div>
              </div>
              <div class="d-flex flex-row bb">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{ 'lang.globals.name' | translate }}</p>
                  <p class="w-100 tr">
                    <input [disabled]="!permissionService.hasPermission(permissionService.Permission.device_properties_edit)" type="text"
                           class="form-control text-right" placeholder="..." [ngModel]="name"
                           (ngModelChange)="onName($event)">
                  </p>
                </div>
              </div>
              <div *ngPermissions="permissionService.Permission.device_pool_show" class="d-flex flex-row bb">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{ 'lang.globals.pool' | translate }}</p>
                  <div ngbDropdown placement="bottom-right" class="w-100 tr" style="margin-top: -14px;">
                    <ng-container
                      *ngIf="permissionService.hasPermissions([permissionService.Permission.device_pool_edit, permissionService.Permission.pool_list]); else poolNoSetPermission">
                      <button class="btn btn-outline-primary" ngbDropdownToggle>
                        <sb-value-definition [text]="getPoolText()"></sb-value-definition>
                      </button>
                      <div ngbDropdownMenu class="scrollable-menu">
                        <button ngbDropdownItem (click)="setPool(null)"
                                [ngClass]="!device.pool ? 'active' : ''"><i>&#91;n.
                          def.&#093;</i></button>
                        <button ngbDropdownItem *ngFor="let pool of pools" (click)="setPool(pool)"
                                [ngClass]="pool === device.pool ? 'active' : ''">{{ pool.name }}
                        </button>
                      </div>
                    </ng-container>
                    <ng-template #poolNoSetPermission>
                      <sb-value-definition [text]="getPoolText()"></sb-value-definition>
                    </ng-template>
                  </div>
                </div>
              </div>
              <div *ngPermissions="permissionService.Permission.device_location_show" class="d-flex flex-row bb">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{ 'lang.globals.location' | translate }}</p>
                  <div class="w-100 tr" style="margin-top: -14px;">
                    <ng-container
                      *ngIf="permissionService.hasPermissions([permissionService.Permission.device_location_edit, permissionService.Permission.location_list]); else locationNoSetPermission">
                      <button class="btn btn-outline-primary" (click)="selectLocation()"
                              [disabled]="!permissionService.hasPermission(permissionService.Permission.device_location_edit)">
                        <sb-value-definition [text]="getLocationText()"></sb-value-definition>
                      </button>
                    </ng-container>
                    <ng-template #locationNoSetPermission>
                      <sb-value-definition [text]="getLocationText()"></sb-value-definition>
                    </ng-template>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-row bb">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{ 'lang.globals.channel' | translate }}</p>
                  <p class="w-100 tr">
                    <sb-value-definition [text]="getChannelText()"></sb-value-definition>
                  </p>
                </div>
              </div>
              <div class="d-flex flex-row bb" *ngIf="device?.screens?.length > 0">
                <div class="mt-3 ml-3 w-100">
                  <h5>
                    {{ 'lang.globals.screens'|translate }}
                  </h5>
                  <div
                    class="mt-3 align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header ml-0">
                    <ng-scrollbar class="mt-2" style="height: 150px; width: 100%" [track]="'vertical'">

                      <div *ngFor="let screen of device?.screens" class="bb tw-mr-5">

                        <div class="d-flex w-100 justify-content-between">
                          <div>{{ 'lang.globals.screen'|translate }}: {{ screen?.id }}</div>
                          <div>{{ screen?.marker?.resolution?.id }}</div>
                        </div>
                        <div
                          class="mt-2 align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                          <p class="w-100">{{ 'lang.globals.name' | translate }}</p>
                          <p class="w-100 tr">
                            <input
                              [disabled]="!permissionService.hasPermission(permissionService.Permission.device_properties_edit) || true"
                              type="text"
                              class="form-control text-right" placeholder="..." [(ngModel)]="screen.name">
                          </p>
                        </div>
                        <div class="d-flex"
                             *ngPermissions="[permissionService.Permission.screen_hardware_list]"
                        >
                          <p class="w-100 tw-flex-wrap">{{ 'lang.globals.screenHardware'| translate }}</p>
                          <div placement="bottom-right" class="w-100 tr"
                               style="margin-top: -14px; padding-top:13px; padding-bottom: 13px;">
                            <sb-comp-dropdown-select
                              [singleSelectMode]="true" [showSubmit]="false"
                              [inputData]="screenHardwareList" [dropDownDatatype]="'SCREEN_HARDWARE'"
                              (selectedDataEmitter)="msUpdate($event, 'SCREEN_HARDWARE', screen)" [showColumnIcon]="false"
                              [showIcon]="false"
                              [msOptions]="msScreenHardwareOptions" (msOptionsChange)="msRequest('SCREEN_HARDWARE', $event)"
                              [selectedInputData]="screen?.hardware ? [screen?.hardware] : []">
                            </sb-comp-dropdown-select>
                          </div>
                        </div>
                        <div class="d-flex"
                             *ngIf="permissionService.hasPermission(permissionService.Permission.medium_transformation_list) && mediumTransformations?.length > 0">
                          <p class="w-100">{{ 'lang.globals.mediumTransformation'|translate }}</p>
                          <div placement="bottom-right" class="w-100 tr"
                               style="margin-top: -14px; padding-top:13px; padding-bottom: 13px;">
                            <sb-comp-dropdown-select
                              [singleSelectMode]="true" [showSubmit]="false"
                              [inputData]="mediumTransformations" [dropDownDatatype]="'MEDIUM_TRANSFORMATION'"
                              (selectedDataEmitter)="msUpdate($event, 'MEDIUM_TRANSFORMATION', screen)" [showColumnIcon]="false"
                              [showIcon]="false"
                              [msOptions]="msMediumTransformationsOptions" (msOptionsChange)="msRequest('MEDIUM_TRANSFORMATION', $event)"
                              [selectedInputData]="screen?.mediumTransformation ? [screen?.mediumTransformation] : []">
                            </sb-comp-dropdown-select>
                          </div>
                        </div>
                      </div>
                    </ng-scrollbar>
                  </div>
                </div>
              </div>

              <div class="d-flex flex-row bb">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{ 'lang.globals.playerHardware' | translate }}</p>
                  <div placement="bottom-right" class="w-100 tr"
                       style="margin-top: -14px; padding-top:13px; padding-bottom: 13px;">
                    <sb-comp-dropdown-select
                      id="Hardware"
                      *ngPermissions="[permissionService.Permission.player_hardware_list]"
                      [singleSelectMode]="true" [showSubmit]="false"
                      [inputData]="playerHardwareList" [dropDownDatatype]="'PLAYER_HARDWARE'"
                      (selectedDataEmitter)="msUpdate($event, 'PLAYER_HARDWARE')" [showColumnIcon]="false"
                      [showIcon]="false"
                      [msOptions]="msPlayerHardwareOptions" (msOptionsChange)="msRequest('PLAYER_HARDWARE', $event)"
                      [selectedInputData]="device?.hardware ? [device?.hardware] : []">
                    </sb-comp-dropdown-select>
                  </div>
                </div>
              </div>

              <div class="d-flex flex-row bb">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{ 'lang.globals.playerSoftware' | translate }}</p>
                  <div placement="bottom-right" class="w-100 tr"
                       style="margin-top: -14px; padding-top:13px; padding-bottom: 13px;">
                    <sb-comp-dropdown-select
                      id="Software"
                      *ngPermissions="[permissionService.Permission.player_software_list]"
                      [singleSelectMode]="true" [showSubmit]="false"
                      [inputData]="playerSoftwareList" [dropDownDatatype]="'PLAYER_SOFTWARE'"
                      (selectedDataEmitter)="msUpdate($event, 'PLAYER_SOFTWARE')" [showColumnIcon]="false"
                      [showIcon]="false"
                      [msOptions]="msPlayerSoftwareOptions" (msOptionsChange)="msRequest('PLAYER_SOFTWARE', $event)"
                      [selectedInputData]="device?.software ? [device?.software] : []">
                    </sb-comp-dropdown-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngPermissions="permissionService.Permission.device_properties_show" class="row mb-2">
          <div class="col-12">
            <div class="tablewrap">
              <div class="mt-3 ml-3">
                <h5>
                  Flags
                </h5>
              </div>
              <div class="d-flex flex-row bb">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{ 'lang.globals.productive' | translate }}</p>
                  <p class="w-100 tr">
                    <sb-toggle-switch [disabled]="!permissionService.hasPermission(permissionService.Permission.device_properties_edit)"
                                      onText="{{ 'lang.globals.yes' | translate }}"
                                      offText="{{ 'lang.globals.no' | translate }}"
                                      [(model)]="device.productive"></sb-toggle-switch>
                  </p>
                </div>
              </div>
              <div class="d-flex flex-row bb">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{ 'lang.globals.noSim' | translate }}</p>
                  <p class="w-100 tr">
                    <sb-toggle-switch [disabled]="!permissionService.hasPermission(permissionService.Permission.device_properties_edit)"
                                      onText="{{ 'lang.globals.yes' | translate }}"
                                      offText="{{ 'lang.globals.no' | translate }}"
                                      [(model)]="device.offline"></sb-toggle-switch>
                  </p>
                </div>
              </div>
              <div class="d-flex flex-row bb">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{ 'lang.globals.disabled' | translate }}</p>
                  <p class="w-100 tr">
                    <sb-toggle-switch [disabled]="!permissionService.hasPermission(permissionService.Permission.device_properties_edit)"
                                      onText="{{ 'lang.globals.yes' | translate }}"
                                      offText="{{ 'lang.globals.no' | translate }}"
                                      [(model)]="device.disabled"></sb-toggle-switch>
                  </p>
                </div>
              </div>
              <div class="d-flex flex-row bb">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{ 'lang.globals.external' | translate }}</p>
                  <p class="w-100 tr">
                    <sb-toggle-switch [disabled]="!permissionService.hasPermission(permissionService.Permission.device_properties_edit)"
                                      onText="{{ 'lang.globals.yes' | translate }}"
                                      offText="{{ 'lang.globals.no' | translate }}"
                                      [(model)]="device.external"></sb-toggle-switch>
                  </p>
                </div>
              </div>
              <div class="d-flex flex-row bb">
                <div
                  class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
                  <p class="w-100">{{ 'lang.globals.mobility' | translate }}</p>
                  <p class="w-100 tr">
                    <sb-toggle-switch [disabled]="!permissionService.hasPermission(permissionService.Permission.device_properties_edit)"
                                      onText="{{ 'lang.globals.yes' | translate }}"
                                      offText="{{ 'lang.globals.no' | translate }}"
                                      [(model)]="isDeviceMobile"></sb-toggle-switch>
                  </p>
                </div>
              </div>
              <div
                class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header"
                *ngIf="isDeviceMobile">
                <!--
                <mat-slider (valueChange)="duration = $event"
                            [disabled]="!isDeviceMobile" [max]="3600"
                            [min]="1" [step]="1" [value]="duration" aria-label="units">
                </mat-slider>
                <div class="input-group">
                -->
                <p class="w-100">{{ 'lang.globals.refreshRate'|translate }} </p>
                <p class="w-100 tr d-flex align-items-center mr-1">
                  <input class="form-control tr" type="number" [min]="1" [max]="86400" [(ngModel)]="duration"
                         [disabled]="!isDeviceMobile || !permissionService.hasPermission(permissionService.Permission.device_properties_edit)"
                         [placeholder]="'seconds'">
                  s

                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="d-flex flex-row bbl">
          <div
            class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
          </div>
        </div>
        <div class="d-flex flex-row">
          <div
            class="mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
            <p class="w-100 tr"></p>
            <p class="w-100 tr">
              <button class="btn btn-primary mr-2"
                      (click)="ok()">{{ 'lang.globals.ok' | translate }}
              </button>
              <button class="btn btn-secondary"
                      (click)="cancel()">{{ 'lang.globals.cancel' | translate }}
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
